<template>
  <div id="app">
    <router-view/>

  </div>
</template>

<script>
  import {setCookie,getCookie} from '@/utils/support.js';
  export default {
    name: 'App',
    created() {
      
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue